export default "__VITE_ASSET__Daw$f7m7__"